import { CompanyMessage } from '../../types/CompanyMessage';

import { translate } from './helpers/translate.helper';
import { useRole } from './hooks/useRole';
import { InfoPopover } from './InfoPopover/InfoPopover';

interface InternalNamePopoverProps {
    company: CompanyMessage;
}

export const InternalNamePopover = ({ company }: InternalNamePopoverProps) => {
    const role = useRole();

    if (!company.internalName) {
        return null;
    }

    const tooltipKey = role.isSuperAdmin() ? 'company.internalName.tooltip.superAdmin' : 'company.internalName.tooltip';

    return <InfoPopover>{translate(tooltipKey, { companyName: company.name })}</InfoPopover>;
};
